import React from 'react';
import { useSelector } from 'react-redux';

import JumpToScorecardButton from './JumpToScorecardButton';

export default function BreedAtAGlanceMobileSection() {
  const { breedData } = useSelector(({ server }) => server);

  return (
    <div className="BreedAtAGlanceMobileSection dn-l">
      <div className="row bg-grayish-blue pt10 pb5 ph5 mb5 font-16">
        <div className="col-12">
          <h3 className="mb4 f6 lh-title">At a glance</h3>
          <ul className="mb7">
            {Object.values(breedData.at_a_glance).map((trait, idx) => (
              <li key={idx} className="flex pv3 bb b--black-10">
                <p className="flex-auto flex-basis-0 fw-medium">
                  {trait.category}
                </p>
                <p className="flex-auto flex-basis-0">{trait.description}</p>
              </li>
            ))}
          </ul>
          <JumpToScorecardButton
            className="fw-medium dark-gray"
            iconPosition="left"
          />
        </div>
      </div>
    </div>
  );
}
